import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutService } from '@core/services';
import { Observable } from 'rxjs';

// A page header's text button with an icon (e.g. View History). On mobile it's just the icon, with its text in a tooltip
@Component({
    selector: 'app-header-button',
    templateUrl: './header-button.component.html',
    styleUrls: ['./header-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderButtonComponent {
  static readonly componentName = 'HeaderButtonComponent';

  @Input() icon: string;
  @Input() text: string;
  @Input() isLoading: boolean;
  @Output() pressed = new EventEmitter<void>();

  public isMobile$: Observable<boolean>;

  constructor(layoutService: LayoutService) {
    this.isMobile$ = layoutService.isMobile$();
  }
}
